<template>
  <v-select
    :items="[$t('all'), ...categories[index]]"
    v-model="category"
    @change="(category) => updateQuery({ category })"
    :outlined="outlined"
    :flat="flat"
    :solo="solo"
    :dense="dense"
    :item-color="itemColor || color"
    :color="color"
    class="cms-filter-select"
    prepend-inner-icon="mdi-filter-outline"
    hide-details
  ></v-select>
</template>
<script>
export default {
  name: 'SelectCategory',
  props: {
    categories: {
      type: Object,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    updateQuery: {
      type: Function,
      required: true,
    },
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
    flat: {
      type: Boolean,
      required: false,
      default: false,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
    solo: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default () { return 'primary'; },
    },
    itemColor: {
      type: String,
      required: false,
    },
  },
  data() {
    const { value } = this;
    return {
      category: value || '',
    }
  },
  watch: {
    category(newValue, oldValue) {
      if(newValue && newValue !== oldValue) {
        this.$emit('input', newValue);
      }
    },
    value(newValue) {
      this.category = newValue;
    }
  },
}
</script>